module.exports = __webpack_public_path__ + "static/media/globalIconDark.e4629c76.svg";